<template>
  <b-overlay :show="isLoading" :opacity="1" spinner fixed spinner-variant="primary" class="mt-5">
    <div v-if="!isLoading" class="login__bg">
      <br>
      <br>
      <!-- <button class="mb-5" @click="callSpidApi">Simulazione loginSpid </button>
      <button @click="verifyToken(token)">Simulazione mando i dati al BE CC</button> -->
      <b-col class="col-12 text-center mb-3">
        <b-col class="col-6 col-sm-4 col-md-3 col-lg-2 mx-auto">
          <b-img :src="require(`@/assets/${$root.scope}/logo_area_pubblica_reg.png`)" alt="logo app" fluid-grow></b-img>
        </b-col>
      </b-col>
      <b-overlay rounded="sm" class="shadowedCard col-sm-12 col-12 col-md-8 col-lgx-6 col-xl-6 mx-auto mb-5">
        <div v-if="modalStep === 1" class="py-5 px-4 text-left">
          <p class="text-secondary mb-5 text-center">Inserisci i dati mancanti per completare la registrazione</p>
          <b-form-group label="Indirizzo" class="py-0">
            <b-form-input v-model="form.address" placeholder="Inserisci indirizzo" required></b-form-input>
          </b-form-group>
          <b-form-group label="CAP">
            <b-form-input v-model="form.cap" placeholder="Inserisci CAP" required></b-form-input>
          </b-form-group>
          <b-form-group label="Email">
            <b-form-input v-model="form.email" type="email" placeholder="Inserisci email"
              :state="form.email ? validEmail() : null" required>
            </b-form-input>
            <b-form-invalid-feedback v-if="form.email && !validEmail()">
              Inserisci un indirizzo email valido.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Numero di telefono">
            <b-input-group class="d-flex align-items-center">
              <b-input-group-prepend>
                <b-form-select class="my-3 text-capitalize prefix-select" name="prefix" v-model="anagrafica.prefix"
                  required>
                  <b-form-select-option v-for="(prefisso, index) in prefissi" :key="`${prefisso.prefisso}-${index}`"
                    :value="prefisso.prefisso">
                    {{ prefisso.flag }} {{ prefisso.prefisso }}
                  </b-form-select-option>
                </b-form-select>
              </b-input-group-prepend>
              <!-- bind al campo anagrafica.tel_number (allineamento RegisterPage) -->
              <b-form-input v-model="anagrafica.tel_number" placeholder="Inserisci numero di telefono"
                :state="anagrafica.tel_number ? validNumber() : null" minlength="9" maxlength="15" required
                @input="onPhoneInput" />
            </b-input-group>
            <b-form-invalid-feedback :force-show="anagrafica.tel_number && !validNumber()">
              Il numero di telefono non può iniziare con 0 o 00, deve contenere solo cifre e avere una lunghezza compresa tra 9 e 15 caratteri.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Progetto" v-if="projects && projects.length">
            <b-form-select v-model="form.project" placeholder="Seleziona progetto" required>
              <b-form-select-option :value="null" disabled>
                --
              </b-form-select-option>
              <option v-for="project in projects" :key="project.hashid" :value="project.hashid">
                {{ project.name }}
              </option>
              <b-form-select-option value="nessuno">{{
                $t("nessun_progetto")
              }}</b-form-select-option>
            </b-form-select>
          </b-form-group>
          <div class="text-right">
            <b-button @click="nextStep" :disabled="!isStep1Valid" variant="secondary" class="mt-2">Avanti</b-button>
          </div>
        </div>

        <div v-else-if="modalStep === 2" class="py-5 px-4 text-left">
          <div class="col-12">
            <h6 class="text-left pb-1">
              {{ $t("termini_condizioni_privacy") }}
            </h6>
            <p class="text-justify informativa__p">
              {{ $t("concludi_registrazione_testo") }}
              <a target="_blank" class="text-underlined point" :href="infoLinks.paziente">
                <u>{{ $t("termini_condizioni_link") }}</u></a>
              e
              <a target="_blank" class="text-underlined point" :href="form.type == 1
                ? privacyPolicyLinks.operatore
                : privacyPolicyLinks.paziente
                ">
                <u>{{ $t("informativa_privacy_link") }}</u></a>
            </p>
            <b-row cols="1" class="text-left">
              <b-form-checkbox class="text-font-light-grey" name="charge_consense" :value="true"
                :unchecked-value="false" v-model="form.charge_consense" :state="form.charge_consense == true">
                <span class="text-dark">{{ $t("accetto_informativa_privacy") }}
                  <a target="_blank" class="text-underlined point" :href="form.type == 1
                    ? privacyPolicyLinks.operatore
                    : privacyPolicyLinks.paziente
                    ">
                    <u>{{ $t("informativa_privacy_link") }}</u></a>
                </span>
              </b-form-checkbox>
              <b-form-checkbox class="text-font-light-grey" name="charge_consense" :value="false"
                :unchecked-value="false" v-model="form.charge_consense" :state="false">
                {{ $t("non_accetto") }}
              </b-form-checkbox>
            </b-row>
            <p class="text-justify informativa__p my-4"></p>
            <b-row cols="1" class="text-left">
              <b-form-checkbox class="text-font-light-grey" name="data_consense" :value="true" :unchecked-value="false"
                v-model="form.data_consense" :state="form.data_consense == true">
                <span class="text-dark">{{ $t("accetto_termini_condizioni") }}
                  <a target="_blank" class="text-underlined point" :href="infoLinks.paziente">
                    <u>{{ $t("termini_condizioni_uso") }}</u></a>
                </span>
              </b-form-checkbox>
              <b-form-checkbox class="text-font-light-grey" name="data_consense" :value="false" :unchecked-value="false"
                v-model="form.data_consense" :state="false">
                {{ $t("non_accetto") }}
              </b-form-checkbox>
            </b-row>
            <p class="text-justify informativa__p my-4">e</p>
            <b-row cols="1" class="text-left">
              <b-form-checkbox class="text-font-light-grey" name="share_consense" :value="true" :unchecked-value="false"
                v-model="form.share_consense" :state="form.share_consense == true">
                <span class="text-dark">Ai sensi dell'articolo 1341 e ss c.c. accetto espressamente
                  le previsioni di cui agli articoli 2, 7, 8, 10, 12 dei
                  presenti
                  <a target="_blank" class="text-underlined point" :href="infoLinks.paziente">
                    <u>{{ $t("termini_condizioni_uso") }}</u></a>
                </span>
              </b-form-checkbox>
              <b-form-checkbox class="text-font-light-grey" name="share_consense" :value="false"
                :unchecked-value="false" v-model="form.share_consense" :state="false">
                {{ $t("non_accetto") }}
              </b-form-checkbox>
            </b-row>
            <h6 class="text-left pt-4 pb-1">
              {{ $t("autorizzazione_marketing") }}
            </h6>
            <b-row cols="1" class="text-left">
              <b-form-checkbox class="text-font-light-grey" name="marketing_consense" :value="true"
                :unchecked-value="false" v-model="form.marketing_consense" :state="form.marketing_consense == true">
                <span class="text-dark">{{ $t("accetto_marketing") }}
                  <a target="_blank" class="text-underlined point" :href="form.type == 1
                    ? privacyPolicyLinks.operatore
                    : privacyPolicyLinks.paziente
                    ">
                    <u>{{ $t("informativa_privacy_link") }}</u></a>
                </span>
              </b-form-checkbox>
              <b-form-checkbox class="text-font-light-grey" name="marketing_consense" :value="false"
                :unchecked-value="false" v-model="form.marketing_consense" :state="false">
                {{ $t("non_accetto") }}
              </b-form-checkbox>
            </b-row>
          </div>
          <div class="d-flex justify-content-between mt-4">
            <b-button @click="prevStep" variant="secondary">Indietro</b-button>
            <b-button @click="submitForm" :disabled="!isStep2Valid" variant="secondary">Conferma</b-button>
          </div>
        </div>
      </b-overlay>
    </div>
  </b-overlay>
</template>

<script>
import { userService } from '../../../_services';
import { mapActions, mapState } from 'vuex';
import { utilityService } from "@/_services";
import { PREFIX_PAESI } from "@/_utils/constants.js"
export default {
  data() {
    return {
      token: null,
      apiResponse: null,
      showModal: false,
      modalStep: 1,
      isLoading: false,
      form: {
        email: null,
        data_consense: false,
        share_consense: false,
        notification_consense: true,
        charge_consense: false,
        marketing_consense: true,
        type: 0,
        project: null,
        // company_code: null,
        anagrafica: null
      },
      anagrafica: {
        regione: null,
        provincia: null,
        comune: null,
        cap: null,
        address: null,
        name: null,
        surname: null,
        cf: null,
        gender: null,
        birthday: null,
        prefix: "+39",
        tel_number: null,
        nazione_nascita: "italia",
        estero: false
      },
      project: null,
      infoLinks: {
        paziente: process.env.VUE_APP_LINK_TC_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_TC_OPERATORE
      },
      privacyPolicyLinks: {
        paziente: process.env.VUE_APP_LINK_INFORMATIVA_PAZIENTE,
        operatore: process.env.VUE_APP_LINK_INFORMATIVA_OPERATORE
      },
      selected: {
        regione: null,
        provincia: null,
        comune: null
      },
      prefissi: PREFIX_PAESI
    };
  },
  computed: {
    ...mapState("utility", [
      "searching",
      "comuni",
      "province",
      "regioni",
      "projects"
    ]),
    // isStep1Valid ora considera anagrafica.tel_number (allineamento)
    isStep1Valid() {
      return this.form.address && this.form.cap && this.validEmail() && this.validNumber() && this.form.project;
    },
    isStep2Valid() {
      return this.form.charge_consense && this.form.data_consense && this.form.share_consense;
    },
    validAge() {
      if (!this.anagrafica.birthday) return false;
      const today = new Date();
      const birthDate = new Date(this.anagrafica.birthday);
      const age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      return age > 14 || (age === 14 && monthDiff >= 0);
    }
  },
  methods: {
    ...mapActions('utility', ['getProjects', 'getComuni', 'getProvince', 'getRegioni']),
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    validNumber() {
      const v = this.anagrafica.tel_number || "";
      if (!v) return false;
      // Nuova regola: solo cifre e lunghezza tra 9 e 15
      const onlyDigitsLen = /^\d{9,15}$/.test(v);
      // Regole esistenti: non deve iniziare con 0/00 e non deve contenere '+'
      const prefix = v.slice(0, 2);
      const hasForbiddenPrefix = prefix === "00" || v.indexOf("+") >= 0 || v.indexOf("0") === 0;
      return onlyDigitsLen && !hasForbiddenPrefix;
    },
    validEmail() {
      // Validazione email con regex standard
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form.email || "");
    },
    onPhoneInput() {
      // Sanitizza e limita il numero direttamente su anagrafica (solo cifre, max 15)
      this.anagrafica.tel_number = (this.anagrafica.tel_number || "").replace(/\D/g, "").slice(0, 15);
    },
    verifyToken(token) {
      this.isLoading = true; // Start loading
      userService
        .verifySpidToken(token)
        .then((response) => {
          // this.isLoading = false; 
          window.location.reload();
        })
        .catch((err) => {
          this.isLoading = false; // Stop loading
          console.log(err);
          if (err && err.status === 404) {
            this.showModal = true;
            const spidUser = err.data.data.user;
            if (spidUser) {
              this.anagrafica.name = spidUser.name;
              this.anagrafica.surname = spidUser.surname;
              this.form.email = spidUser.email;
              this.anagrafica.cf = spidUser.cf;
              this.anagrafica.gender = spidUser.gender;
              this.anagrafica.birthday = spidUser.birthday;
              this.fillComuneFromCF();
            }
          } else {
            console.error('Errore durante la verifica token su backend CC:', err);
          }
        });
    },
    findProjectName(hashid) {
      return this.projects.find((el) => el.hashid === hashid)
    },
    nextStep() {
      this.modalStep = 2;
    },
    prevStep() {
      this.modalStep = 1;
    },
    searchComuneViaCCatastale(codice) {
      const self = this;
      utilityService
        .searchComuneViaCodiceCatastale(codice)
        .then(function (res) {
          if (res.data.data) {
            self.selected.regione = res.data.data.regione;
            self.getProvince(res.data.data);
            self.selected.provincia = res.data.data.provincia;
            self.getComuni(res.data.data);
            self.selected.comune = res.data.data;

            // Populate anagrafica fields
            self.anagrafica.regione = res.data.data.regione;
            self.anagrafica.provincia = res.data.data.provincia;
            self.anagrafica.comune = res.data.data.comune;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    fillComuneFromCF() {
      if (this.anagrafica.cf) {
        // Rimuovi il prefisso 'TINIT-' se presente
        if (this.anagrafica.cf.startsWith('TINIT-')) {
          this.anagrafica.cf = this.anagrafica.cf.replace('TINIT-', '');
        }

        // Controlla la lunghezza del codice fiscale
        if (this.anagrafica.cf.length === 16) {
          const codiceCatastale = this.anagrafica.cf.substr(11, 4);
          this.searchComuneViaCCatastale(codiceCatastale);
        }
      }
    },
    submitForm() {
      this.anagrafica.address = this.form.address;
      this.anagrafica.cap = this.form.cap;

      delete this.form.address;
      delete this.form.cap;

      this.form.anagrafica = this.anagrafica;

      userService.registerBySpid(this.form)
        .then(response => {
          this.$router.push({
            name: "EmailVerification",
            params: { status: "invalid" },
          });
        })
        .catch(error => {
          console.error('Errore durante la registrazione:', error);
          let msg = "Errore durante la registrazione.";
          const data = error && error.data ? error.data : null;
          if (data && data.errors && typeof data.errors === 'object') {
            if (data.errors['anagrafica.cf'] && Array.isArray(data.errors['anagrafica.cf']) && data.errors['anagrafica.cf'][0]) {
              msg = data.errors['anagrafica.cf'][0];
            } else {
              for (const k in data.errors) {
                const v = data.errors[k];
                if (Array.isArray(v) && v.length) { msg = v[0]; break; }
                if (typeof v === 'string' && v) { msg = v; break; }
              }
            }
          } else if (data && data.message) {
            msg = data.message;
          }
          this.errorAlert(msg);
        });
    },
  },
  watch: {
    "anagrafica.cf": function (newVal) {
      if (newVal && newVal.length === 16) {
        this.fillComuneFromCF();
      }
    }
  },
  created() {
    this.getProjects({ active: true, public: true });
    this.getRegioni();

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    const error = urlParams.get('error');

    if (token) {
      this.verifyToken(token);
    }

    if (error) {
      const decodedError = decodeURIComponent(error);
      this.errorAlert(decodedError);
      setTimeout(() => {
        this.$router.push({ path: '/login' });
      }, 5000);
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 768px) {
  .shadowedCard {
    width: 90%;
    margin: 0 auto;
    padding: 1.5rem;
  }
}

/* no custom spinner styles per request; using b-overlay props */
</style>